export const backendUrl = {
    localhost: 'http://localhost:8800',
    dev: 'https://aas-apidev.sbp.eyclienthub.com',
    dev2: 'https://aas-apidev2.sbp.eyclienthub.com',
    qa: 'https://aas-apiqa.sbp.eyclienthub.com',
    qa2: 'https://aas-apiqa2.sbp.eyclienthub.com',
    stg: 'https://aas-stgapi.sbp.eyclienthub.com',
    uat: 'https://cap-stagingapi.sbp.eyclienthub.com',
    prod: 'https://ah-api.ey.com',
  }

  export const getBackendUrl = ()  => {
    let curUrl: string = window.location.href.split('//')[1].split('/')[0]
  
    if (curUrl === 'localhost:3000') {
      return backendUrl['localhost']
    } else if (curUrl === 'aas-dev.sbp.eyclienthub.com') {
      return backendUrl['dev']
    } else if (curUrl === 'aas-dev2.sbp.eyclienthub.com') {
      return backendUrl['dev2']
    } else if (curUrl === 'aas-qa.sbp.eyclienthub.com') {
      return backendUrl['qa']
    } else if (curUrl === 'aas-qa2.sbp.eyclienthub.com') {
      return backendUrl['qa2']
    } else if (curUrl === 'aas-stg.sbp.eyclienthub.com') {
      return backendUrl['stg']
    } else if (curUrl === 'cap-staging.sbp.eyclienthub.com') {
      return backendUrl['uat']
    } else if (curUrl === 'ah.ey.com') {
      return backendUrl['prod']
    }
  }